import { useCurrentUser } from '@cma/app'
import { Navigation } from '@cma/app/Navigation'
import { Avatar } from '@cma/common'
import { getAccessTokens } from '@cma/features/auth'
import { ArrowLeftIcon } from '@cma/icons'
import { HelixIcon } from '@helix/helix-icon'
import { chevron_left as ChevronLeftIcon } from '@helix/helix-icon/outlined'
import { NavbarBody, NavbarIconAction } from '@helix/navbar'
import { usePlatformClient } from './usePlatformClient'

export function AdminPanelHeader() {
  const { data: { currentUser } = {} } = useCurrentUser()
  const { data: { platformClient } = {} } = usePlatformClient({
    id: currentUser?.account?.id || ''
  })
  const accessTokens = getAccessTokens()

  const canUseNewNavigation =
    !!currentUser?.lwaJwt &&
    !accessTokens?.impersonateToken &&
    !currentUser.isAuthSso

  return (
    <>
      {canUseNewNavigation ? (
        <Navigation
          style={{ zIndex: 10 }}
          hideClientSwitcher
          navbody={
            <NavbarBody className="helix-d-flex">
              <NavbarIconAction
                role="link"
                tabIndex={0}
                onClick={() =>
                  window.location.assign(process.env.VITE_APP_CMA_URL)
                }
                onKeyDown={(e) =>
                  e.key === 'Enter' &&
                  window.location.assign(process.env.VITE_APP_CMA_URL)
                }
                icon={
                  <HelixIcon
                    className="helix-svg-fill--brand"
                    icon={ChevronLeftIcon}
                  />
                }>
                <span className="helix-text-brand">Back</span>
              </NavbarIconAction>
              <div className="helix-d-flex helix-flex-1 helix-align--middle helix-flex-direction--column">
                <div className="helix-heading">
                  {platformClient?.platformAccountName || ''}
                </div>
                <div className="helix-small">
                  Manage the company's content and brands
                </div>
              </div>
            </NavbarBody>
          }
        />
      ) : (
        <div className="sticky top-0 z-10 flex h-[3.75rem] items-center bg-white p-2 text-xl leading-6 [box-shadow:0_0_1px_rgb(0_0_0_/_20%)] sm:px-8">
          <div className="flex w-2/12">
            <a
              href={`${process.env.VITE_APP_CMA_URL}`}
              className="flex items-center gap-3 hover:no-underline">
              <ArrowLeftIcon className="h-5 w-5 flex-shrink-0" />
              <span className="helix-body--strong">Previous page</span>
            </a>
          </div>
          <div className="flex w-8/12 flex-col items-center justify-center text-gray-900">
            <div
              title={platformClient?.platformAccountName || ''}
              className="helix-heading truncate">
              {platformClient?.platformAccountName || ''}
            </div>
            <div className="helix-body text-gray-600">
              Manage the company's content and brands
            </div>
          </div>
          <div className="flex w-2/12 items-center justify-end">
            <Avatar
              name={currentUser?.name}
              src={currentUser?.avatar || undefined}
              size="sm"
            />
          </div>
        </div>
      )}
    </>
  )
}
